export type TagProps = {
	className?: string;
	classIcon?: string;
	name?: string;
	icon?: JSX.Element;
};

export function Tag({ className = '', icon, classIcon, name }: TagProps) {
	return (
		<div data-testid='class-name' className={`${className} flex items-center`}>
			<div data-testid='class-icon' className={`${classIcon} inline mr-1`}>
				<div data-testid='tag-icon'>
					<>{icon}</>
				</div>
			</div>{' '}
			<span className='font-semibold'>{name}</span>
		</div>
	);
}
